import api from '@pray/shared/utils/api';

import type { WorkflowResponse } from './data/response';

type GetWorkflowProps = {
  artistId: string;
  workflowId: string;
};

export async function getWorkflow({ artistId, workflowId }: GetWorkflowProps): Promise<WorkflowResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}`;

  const response = await api.executeGetRequest<WorkflowResponse>(url);
  return response.data;
}
